import React from 'react'
import { Grid } from 'semantic-ui-react'
import { MENU } from '../constants'
import styles from './navigation.module.css'

import NavigationButton from './navigation-button'
import TextTitle from './text-title'
import PropTypes from "prop-types";

function Navigation(props) {

    Navigation.propTypes = {
        changeCorpSector: PropTypes.func.isRequired,
        selected: PropTypes.string
    }

  return (
    <nav className={styles.nav}>
        <Grid doubling columns={7}>
      {MENU.map((menu) => {
        const showTitle = !false || menu.title.length === 0;
          const selected = props.selectedSector ;
        return (
            <Grid.Column key={menu.key}>
          <NavigationButton
            key={menu.key}
            selected ={props.selected == menu.key}
            onClick = {(e) => props.changeCorpSector(menu.key)}
            className={styles.navButton}
          >
            {menu.icon}
            {showTitle && <TextTitle  bold={false}>{menu.title}</TextTitle>}
          </NavigationButton>
                </Grid.Column>
        )
      })}
      </Grid>
    </nav>
  )
}

export default Navigation
